import {useQuery, UseQueryResult} from "react-query";
import {getFrontVersion} from "./frontVersion.services";


export const useGetFrontVersion = ():UseQueryResult<FrontVersion, Error>=>{
    return useQuery<FrontVersion, Error>(["front_version"], getFrontVersion, {
        staleTime:1000
    })
}